import React from 'react';
import { css } from '@emotion/react';
import BlogIcon from '$/images/menuBlog.svg';
import WebinarLibraryIcon from '$/images/menuWebinarLibrary.svg';
import WebinarTemplatesIcon from '$/images/menuWebinarTemplates.svg';
import HelpCenterIcon from '$/images/menuHelpCenter.svg';
import config from '$/config';

export interface MarketingMenuChild {
  title: string;
  description: string;
  icon: JSX.Element;
  link: string;
  target?: string;
}
export interface MarketingMenu {
  textColor?: string;
  bgColor?: string;
  children: MarketingMenuChild[];
}

const ResourcesMenu: React.FC<{ target?: string }> = ({ target }): JSX.Element => {
  const SubMenuList: MarketingMenu[] = [
    {
      textColor: 'teal-1',
      bgColor: 'bg-teal-8',
      children: [
        {
          title: 'Webinar templates',
          description: `Use our free templates for sales, marketing, and customer success webinars instead of building the experience from scratch.`,
          icon: <img src={WebinarTemplatesIcon} />,
          link: `${config.URL_MARKETING_SITE}/webinar-templates`,
        },
        {
          title: 'Webinar library',
          description: `Browse our library of free automated webinars to learn something new and get ideas for your own webinars.`,
          icon: <img src={WebinarLibraryIcon} />,
          link: `${config.URL_MARKETING_SITE}/automated-webinar-library`,
        },
        {
          title: 'Blog',
          description: `Learn strategies for how to get the most out of your automated webinars and find out about new features and product updates.`,
          icon: <img src={BlogIcon} />,
          link: `${config.URL_MARKETING_SITE}/blog`,
        },
        {
          title: 'Help center',
          description: `Search our collection of helpful articles and tutorial videos explaining how to create, set up, and manage all of your eWebinars.`,
          icon: <img src={HelpCenterIcon} />,
          link: `${config.URL_MARKETING_SITE}/help`,
        },
      ],
    },
  ];
  return (
    <section
      className='md:absolute left-0 rounded-sm hidden bg-white text-xs md:text-sm menu-sub'
      css={css`
        width: 25rem;
      `}
    >
      <div className='flex md:justify-between md:px-2'>
        {SubMenuList.map((item, index) => {
          const itemChilds = item.children;

          return (
            <div className='w-full text-left md:px-2 col-sub' key={index}>
              <ul className='my-2'>
                {itemChilds.map((itemChild, indexChild) => {
                  return (
                    <li key={indexChild}>
                      <a
                        href={itemChild.link}
                        onClick={(e): void => {
                          !itemChild.link && e.preventDefault();
                        }}
                        target={target || itemChild.target}
                        className={`text-gray-28 itemSubmenu flex normal-case no-underline items-center md:items-start md:p-4 py-2 px-4 mr-0 transition-100 rounded-lg hover:${item.bgColor}`}
                      >
                        {/* icon */}
                        <i className='items-center flex mr-4 flex-none w-10 h-10 rounded-full bg-gray-300 p-2'>
                          {itemChild.icon}
                        </i>
                        <div>
                          <h6 className='md:mb-2'>{itemChild.title}</h6>
                          <p className='leading-normal hidden md:block description'>
                            {itemChild.description}
                          </p>
                        </div>
                      </a>
                    </li>
                  );
                })}
              </ul>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default ResourcesMenu;
